import React, { useEffect } from 'react';
import { Layers, Server, Network } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const Architecture = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('architecture');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'System Design',
      icon: Layers,
      description: 'Database architecture patterns, design principles, and scalability considerations.',
      scripts: getContentByCategory('Architecture and Configuration', 'System Design')
    },
    {
      name: 'Server Configuration',
      icon: Server,
      description: 'Optimal server settings, resource allocation, and performance tuning configurations.',
      scripts: getContentByCategory('Architecture and Configuration', 'Server Configuration')
    },
    {
      name: 'Network Setup',
      icon: Network,
      description: 'Network configuration, connectivity settings, and distributed system setup.',
      scripts: getContentByCategory('Architecture and Configuration', 'Network Setup')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Architecture & Configuration</h1>
        <p className="page-description">
          Design robust SQL Server architectures with optimal configurations. Learn system design 
          patterns, server tuning, and network setup for enterprise environments.
        </p>
      </div>

      <CategoryTabs 
        category="Architecture and Configuration"
        scripts={getContentByCategory('Architecture and Configuration')}
        articles={getContentByCategory('Architecture and Configuration', null, 'articles')}
        faqs={getContentByCategory('Architecture and Configuration', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default Architecture;